import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import {
  UpdateAssemblyDocumentBIZcoreTD
} from '../../../../../redux/actions/business/core/tradeDefencesActions';

import global from "../../../../../global.scss";

const MODES = { CREATE: 1, EDIT: 2 };

const DOC_TYPE_CHOICES = [
  "MASTER_DATA",
  "COMMERCIAL_INVOICE",
  "BILL_OF_LADING",
  "FORM_7501",
  "PIVOT_TABLE",
];

const Data = {
  SessionId: "",
  DocType: "",
  FileName: "",
  ExtractionStatus: "",
  CompletenessPct: "",
  HasError: "",
};

const AssemblyDocumentModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.CREATE);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.CREATE);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        // if (update.defaultMode === MODES.CREATE) {
        //   setMode(MODES.CREATE);
        //   setFormData(Data);
        // } else 
        if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            SessionId: update.ref_session_id || "",
            DocType: update.doc_type || "",
            FileName: update.file_name || "",
            ExtractionStatus: update.extraction_status || "",
            CompletenessPct: update.completeness_pct ?? "",
            HasError: update.has_error !== undefined ? update.has_error : "",
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      ref_session_id: formData.SessionId,
      doc_type: formData.DocType,
      file_name: formData.FileName,
      extraction_status: formData.ExtractionStatus || null,
      completeness_pct: formData.CompletenessPct !== "" ? parseInt(formData.CompletenessPct, 10) : null,
      has_error: formData.HasError,
    };

    // if (mode === MODES.CREATE) {
    //   dispatch(CreateAssemblyDocumentBIZcoreTD(obj, setLoading)).then(() => {
    //     handleGet(setLoading).then(() => {
    //       handleClose();
    //     });
    //   });
    // } else 
    if (mode === MODES.EDIT) {
      dispatch(UpdateAssemblyDocumentBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  const isSubmitDisabled = !(
    formData.SessionId !== "" &&
    formData.DocType !== "" &&
    formData.FileName !== "" &&
    formData.HasError !== ""
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* Session ID */}
            <Box mb={"15px"}>
              <TextField
                label="Session ID"
                fullWidth
                name="SessionId"
                value={formData.SessionId}
                onChange={handleChange}
                disabled={mode === MODES.EDIT}
                inputProps={{ maxLength: 36 }}
              />
            </Box>

            {/* Doc type + File name */}
            <Box className="flexCenterSBRow" gap={"15px"} mb={"15px"}>
              <TextField
                select
                label="Document type"
                fullWidth
                name="DocType"
                value={formData.DocType}
                onChange={handleChange}
              >
                {DOC_TYPE_CHOICES.map((choice) => (
                  <MenuItem key={choice} value={choice}>{choice}</MenuItem>
                ))}
              </TextField>
              <TextField
                label="File name"
                fullWidth
                name="FileName"
                value={formData.FileName}
                onChange={handleChange}
                inputProps={{ maxLength: 255 }}
              />
            </Box>

            {/* Extraction status + Completeness pct */}
            <Box className="flexCenterSBRow" gap={"15px"} mb={"15px"}>
              <TextField
                label="Extraction status"
                fullWidth
                name="ExtractionStatus"
                value={formData.ExtractionStatus}
                onChange={handleChange}
                inputProps={{ maxLength: 255 }}
              />
              <TextField
                label="Completeness %"
                fullWidth
                type="number"
                name="CompletenessPct"
                value={formData.CompletenessPct}
                onChange={handleChange}
                inputProps={{ min: 0, max: 100 }}
              />
            </Box>

            {/* Has error */}
            <Box mb={"15px"}>
              <TextField
                select
                label="Has error"
                fullWidth
                name="HasError"
                value={formData.HasError}
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>
          </Box>
          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={isSubmitDisabled}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AssemblyDocumentModal;
